import { ReactNode } from 'react';

interface TablePageProps {
  children: ReactNode;
  className?: string;
}

/**
 * Page-level wrapper for table screens. Establishes a bounded flex column inside the
 * scrollable <main> so a <DataTable fillHeight> child fills the remaining vertical space
 * instead of relying on a hardcoded `calc(100dvh - Xrem)` height.
 *
 * Usage: place breadcrumbs / banners / top sections as natural-height children (give tall
 * ones `shrink-0`), then a single <DataTable fillHeight /> which is the only growing child.
 *
 * `h-full` resolves against <main>'s flex-resolved height (App.tsx), and `min-h-0` lets this
 * wrapper shrink so the table's scroll box can own its own scrollbar. On very short viewports
 * the table holds its floor height and <main> scrolls as the escape hatch.
 */
export const TablePage = ({ children, className }: TablePageProps) => {
  return (
    <div className={`flex flex-col h-full min-h-0 ${className ?? ''}`}>
      {children}
    </div>
  );
};

export default TablePage;
